module.exports = __webpack_public_path__ + "img/proyecto_5.cca7ad89.webp";